/* istanbul ignore file */
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
import { minBreakpoints } from "../constants/breakpoints";
export var GRID_COLUMN_GAP_SMALL = 12;
export var GRID_COLUMN_GAP_MEDIUM = 20;
export var GRID_COLUMN_GAP_LARGE = 20;
export var GRID_COLUMN_GAP_XLARGE = 24;
var DEFAULT_GRID_ROW_GAP_SMALL = 32;
var DEFAULT_GRID_ROW_GAP_LARGE = 64;
var GUTTER_SMALL = '16px';
var GUTTER_MEDIUM = '16px';
var GUTTER_LARGE = '24px';
var GUTTER_XLARGE = '24px';
var MAXIMUM_CONTENT_WIDTH = '1440px';
var MAX_CONTENT_WIDTH_AVOIDING_FOCUS_CROP = '1450px';
var PERSISTENT_UI_WIDTH = '192px';
export var GRID_NUMBER_OF_COLUMNS = 12;
export var createGrid = function createGrid(_ref) {
  var _ref$columnGapLarge = _ref.columnGapLarge,
    columnGapLarge = _ref$columnGapLarge === void 0 ? GRID_COLUMN_GAP_LARGE : _ref$columnGapLarge,
    _ref$columnGapMedium = _ref.columnGapMedium,
    columnGapMedium = _ref$columnGapMedium === void 0 ? GRID_COLUMN_GAP_MEDIUM : _ref$columnGapMedium,
    _ref$columnGapSmall = _ref.columnGapSmall,
    columnGapSmall = _ref$columnGapSmall === void 0 ? GRID_COLUMN_GAP_SMALL : _ref$columnGapSmall,
    _ref$columnGapXLarge = _ref.columnGapXLarge,
    columnGapXLarge = _ref$columnGapXLarge === void 0 ? GRID_COLUMN_GAP_XLARGE : _ref$columnGapXLarge,
    numberOfColumns = _ref.numberOfColumns,
    _ref$rowGapLarge = _ref.rowGapLarge,
    rowGapLarge = _ref$rowGapLarge === void 0 ? DEFAULT_GRID_ROW_GAP_LARGE : _ref$rowGapLarge,
    _ref$rowGapMedium = _ref.rowGapMedium,
    rowGapMedium = _ref$rowGapMedium === void 0 ? DEFAULT_GRID_ROW_GAP_SMALL : _ref$rowGapMedium,
    _ref$rowGapSmall = _ref.rowGapSmall,
    rowGapSmall = _ref$rowGapSmall === void 0 ? DEFAULT_GRID_ROW_GAP_SMALL : _ref$rowGapSmall,
    _ref$rowGapXLarge = _ref.rowGapXLarge,
    rowGapXLarge = _ref$rowGapXLarge === void 0 ? DEFAULT_GRID_ROW_GAP_LARGE : _ref$rowGapXLarge;
  return css(["display:grid;grid-column-gap:", "px;grid-row-gap:", "px;grid-template-columns:repeat(", ",1fr);", ";", ";", ";"], columnGapSmall, rowGapSmall, numberOfColumns, mediaQuery({
    min: minBreakpoints.M
  }, css(["grid-column-gap:", "px;grid-row-gap:", "px;"], columnGapMedium, rowGapMedium)), mediaQuery({
    min: minBreakpoints.L
  }, css(["grid-column-gap:", "px;grid-row-gap:", "px;"], columnGapLarge, rowGapLarge)), mediaQuery({
    min: minBreakpoints.XL
  }, css(["grid-column-gap:", "px;grid-row-gap:", "px;"], columnGapXLarge, rowGapXLarge)));
};
export var grid = createGrid({
  numberOfColumns: GRID_NUMBER_OF_COLUMNS
});
export var containerWithGutters = /*#__PURE__*/css(["padding-left:", ";padding-right:", ";", ";", ";", ";"], GUTTER_SMALL, GUTTER_SMALL, mediaQuery({
  min: minBreakpoints.M
}, css(["padding-left:", ";padding-right:", ";"], GUTTER_MEDIUM, GUTTER_MEDIUM)), mediaQuery({
  min: minBreakpoints.L
}, css(["padding-left:", ";padding-right:", ";"], GUTTER_LARGE, GUTTER_LARGE)), mediaQuery({
  min: minBreakpoints.XL
}, css(["padding-left:", ";padding-right:", ";"], GUTTER_XLARGE, GUTTER_XLARGE)));
export var maxWidthContainerWithoutGutters = /*#__PURE__*/css(["margin:0 auto;", ";"], mediaQuery({
  min: minBreakpoints.XL
}, css(["max-width:", ";"], MAXIMUM_CONTENT_WIDTH)));
var extraMaxWidthContainerWithoutGutters = /*#__PURE__*/css(["margin:0 auto;", ";"], mediaQuery({
  min: minBreakpoints.XL
}, css(["max-width:", ";"], MAX_CONTENT_WIDTH_AVOIDING_FOCUS_CROP)));
export var maxWidthContainer = /*#__PURE__*/css(["", " ", ";"], maxWidthContainerWithoutGutters, containerWithGutters);
export var extraMaxWidthContainer = /*#__PURE__*/css(["", " ", ";"], extraMaxWidthContainerWithoutGutters, containerWithGutters);
export var persistentUIContainer = /*#__PURE__*/css(["margin:0 auto;padding-left:", ";padding-right:", ";", ";", ";", ";"], GUTTER_SMALL, GUTTER_SMALL, mediaQuery({
  min: minBreakpoints.M
}, css(["padding-left:", ";padding-right:", ";"], GUTTER_MEDIUM, GUTTER_MEDIUM)), mediaQuery({
  min: minBreakpoints.L
}, css(["display:grid;grid-column-gap:", ";grid-template-columns:", " 1fr;padding-left:", ";padding-right:", ";"], GUTTER_LARGE, PERSISTENT_UI_WIDTH, GUTTER_LARGE, GUTTER_LARGE)), mediaQuery({
  min: minBreakpoints.XL
}, css(["padding-left:", ";padding-right:", ";max-width:", ";"], GUTTER_XLARGE, GUTTER_XLARGE, MAXIMUM_CONTENT_WIDTH)));